import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Product } from '@shared/models';
import { ProductThumbnailComponent } from '../../../../shared/product-thumbnail/product-thumbnail.component';

@Component({
    selector: 'app-products-row-type-2',
    templateUrl: './products-row-type-2.component.html',
    styleUrls: ['./products-row-type-2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductThumbnailComponent],
})
export class ProductsRowType2Component {
    @Input({ required: true }) products!: Product[];

    get firstProduct(): Product {
        return this.products.slice(0, 1)[0];
    }

    get restOfProducts(): Product[] {
        return this.products.slice(1, this.products.length);
    }
}
